import type { Label } from '../../lib/tasksApi';

interface LabelPillProps {
  label: Pick<Label, 'name' | 'color'>;
  onRemove?: () => void;
}

// Decide readable text color (black/white) from the pill background hex.
function contrastText(hex: string): string {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex);
  if (!m) return '#111827';
  const int = parseInt(m[1], 16);
  const r = (int >> 16) & 0xff;
  const g = (int >> 8) & 0xff;
  const b = int & 0xff;
  // Relative luminance (sRGB approximation).
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#111827' : '#ffffff';
}

export function LabelPill({ label, onRemove }: LabelPillProps) {
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium"
      style={{ backgroundColor: label.color, color: contrastText(label.color) }}
    >
      {label.name}
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="opacity-70 hover:opacity-100"
          aria-label={`Elimină ${label.name}`}
        >
          ×
        </button>
      )}
    </span>
  );
}
